import script from "./ListasClienteCadastro.vue?vue&type=script&setup=true&lang=js"
export * from "./ListasClienteCadastro.vue?vue&type=script&setup=true&lang=js"

import "./ListasClienteCadastro.vue?vue&type=style&index=0&id=4cd94435&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cd94435"]])

export default __exports__